import * as types from '../types/Vacancies';

export const vacancyInnerDetailsRequest = payload => ({
    type: types.VACANCY_INNER_DETAILS_REQUEST,
    payload
})
export const vacancyInnerDetailsReceive = payload => ({
    type: types.VACANCY_INNER_DETAILS_RECEIVE,
    payload
})